import React from 'react';
import { observer } from 'mobx-react';
import { GridMultilineBooleanCellTemplate } from 'themes/components';

@observer
class GridMultilineBooleanCell extends React.Component {
    render() {
        return (
            <GridMultilineBooleanCellTemplate {...this.props}/>
        );
    }
}

export default GridMultilineBooleanCell;